const VALID_STATUSES = ['purchased', 'public_domain', 'no_rights_reserved'];
const REQUIRE_EXPIRY = ['purchased'];

export function imageHasValidRights(
  imageCopyrightStatus: string | null,
  imageCopyrightExpiryDate: string | null,
): boolean {
  if (!imageCopyrightStatus || !VALID_STATUSES.includes(imageCopyrightStatus)) {
    return false;
  }

  if (
    REQUIRE_EXPIRY.includes(imageCopyrightStatus) &&
    (!imageCopyrightExpiryDate || new Date() > new Date(imageCopyrightExpiryDate))
  ) {
    return false;
  }

  return true;
}
